/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 17:12:48
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 17:14:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/slice/contant.ts
 */
export enum EnumReducers {
  reviewDetail = 'reviewDetail',
  reviewList = 'reviewList',
}
